import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const getAuthMeta = (role, stack = undefined) => ({
  role,
  auth: true,
  stack,
});

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/admin',
    redirect: '/admin/home',
  },
  {
    path: '/sale',
    redirect: '/sale/home',
  },
  {
    path: '/qr-scanner',
    redirect: '/qr-scanner/coupon',
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Auth.vue'),
    children: [
      {
        path: '/welcome',
        name: 'Welcome',
        meta: getAuthMeta('merchant', { type: 'signUp', index: 0 }),
        component: () => import(/* webpackChunkName: "welcome" */ '../views/auth/Welcome.vue'),
      },
      {
        path: '/signup',
        name: 'SignUp',
        meta: getAuthMeta('merchant', { type: 'signUp', index: 1 }),
        component: () => import(/* webpackChunkName: "sign-up" */ '../views/auth/SignUp.vue'),
      },
      {
        path: '/login',
        name: 'MerchantLogin',
        meta: getAuthMeta('merchant', { type: 'login', index: 0 }),
        component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue'),
      },
      {
        path: '/forgetPassword',
        name: 'ForgetPassword',
        meta: getAuthMeta('merchant', { type: 'login', index: 1 }),
        component: () => import(/* webpackChunkName: "forget-password" */ '../views/auth/ForgetPassword.vue'),
      },
      {
        path: '/sent',
        name: 'Sent',
        meta: getAuthMeta('merchant', { type: 'login', index: 2 }),
        component: () => import(/* webpackChunkName: "sent" */ '../views/auth/Sent.vue'),
      },
      {
        path: '/resetPassword',
        name: 'ResetPassword',
        meta: getAuthMeta('merchant', { type: 'login', index: 3 }),
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/auth/ResetPassword.vue'),
      },
      {
        path: '/admin/login',
        name: 'AdminLogin',
        meta: getAuthMeta('admin', { type: 'login', index: 0 }),
        component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue'),
      },
      {
        path: '/sale/login',
        name: 'SaleLogin',
        meta: getAuthMeta('sale', { type: 'login', index: 0 }),
        component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue'),
      },
      {
        path: '/qr-scanner/subMerchantLogin',
        name: 'SubMerchantLogin',
        meta: getAuthMeta('sub-merchant', { type: 'subMerchantLogin', index: 0 }),
        component: () => import(/* webpackChunkName: "sub-merchant-login" */ '../views/auth/SubMerchantLogin.vue'),
      },
      // {
      //   path: '/qr-scanner/order',
      //   name: 'QrCodeRedemptionRec',
      //   // meta: getAuthMeta('sub-merchant', { type: 'login', index: 0 }),
      //   component: () => import(/* webpackChunkName: "qrcode-redemption-rec" */
      // '../views/qr-scanner/RedemptionRecords.vue'),
      // },
    ],
  },
  {
    path: '/(admin/|sale/)?home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
  },
  {
    path: '/(admin/|sale/)?coupons',
    name: 'ListCoupons',
    meta: { paymentType: 'UFUN' },
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/coupons/ListCoupons.vue'),
  },
  {
    path: '/(admin/|sale/)?paidCoupons',
    name: 'ListPaidCoupons',
    meta: { paymentType: 'HKD' },
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/coupons/ListCoupons.vue'),
  },
  {
    path: '/(admin/|sale/)?checkinCoupons',
    name: 'ListCheckinCoupons',
    meta: { paymentType: 'UFUN', couponType: 'checkin' },
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/coupons/ListCoupons.vue'),
  },
  {
    path: '/(admin/|sale/)?coupons/add',
    name: 'AddCoupon',
    meta: { paymentType: 'UFUN' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    path: '/(admin/|sale/)?coupons/:id(\\d+)',
    name: 'EditCoupon',
    meta: { controller: 'coupons', paymentType: 'UFUN' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    path: '/(admin/|sale/)?paidCoupons/add',
    name: 'AddPaymentCoupon',
    meta: { paymentType: 'HKD' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    path: '/(admin/|sale/)?paidCoupons/:id(\\d+)',
    name: 'EditPaymentCoupon',
    meta: { controller: 'coupons', paymentType: 'HKD' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    path: '/(admin/|sale/)?checkinCoupons/add',
    name: 'AddCheckinCoupon',
    meta: { paymentType: 'UFUN', couponType: 'checkin' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    path: '/(admin/|sale/)?checkinCoupons/:id(\\d+)',
    name: 'EditCheckinCoupon',
    meta: { controller: 'coupons', paymentType: 'UFUN', couponType: 'checkin' },
    component: () => import(/* webpackChunkName: "edit-coupon" */ '../views/coupons/EditCoupon.vue'),
  },
  {
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/salesorder/ListCoupons.vue'),
    path: '/(admin/|sale/)?salesorder',
    name: 'ListSalesOrder',
  },
  {
    path: '/(admin/|sale/)?salesorder/:id(\\d+)',
    name: 'SalesOrderDetail',
    meta: { controller: 'salesorder' },
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/salesorder/Detail.vue'),
  },
  {
    path: '/(admin/|sale/)?paymentRecords',
    name: 'ListRecords',
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/paymentrecord/ListRecords.vue'),
  },
  {
    path: '/(admin/|sale/)?paymentRecords/:id(\\d+)',
    name: 'EditRecord',
    component: () => import(/* webpackChunkName: "list-coupons" */ '../views/paymentrecord/EditRecord.vue'),
  },
  {
    path: '/(admin/|sale/)merchants',
    name: 'ListMerchants',
    component: () => import(/* webpackChunkName: "list-merchants" */ '../views/merchants/ListMerchants.vue'),
  },
  {
    path: '/(admin/|sale/)merchants/:id(\\d+)',
    name: 'EditMerchant',
    meta: { controller: 'merchants' },
    component: () => import(/* webpackChunkName: "edit-merchant" */ '../views/merchants/EditMerchant.vue'),
  },
  {
    path: '/admin/sales',
    name: 'ListSales',
    component: () => import(/* webpackChunkName: "list-sales" */ '../views/sales/ListSales.vue'),
  },
  {
    path: '/admin/sales/:id(\\d+)',
    name: 'EditSale',
    meta: { controller: 'sales' },
    component: () => import(/* webpackChunkName: "edit-sale" */ '../views/sales/EditSale.vue'),
  },
  {
    component: () => import(/* webpackChunkName: "list-statistics" */ '../views/statistics/ListStatistics.vue'),
    path: '/(admin/|sale/)?statistics',
    name: 'ListReports',
  },
  {
    path: '/(admin/|sale/)?notification',
    name: 'ListNotification',
    component: () => import(/* webpackChunkName: "list-notification" */ '../views/notification/ListNotification.vue'),
  },
  {
    path: '/admin/notification/add-blog',
    name: 'AddBlogNotification',
    component: () => import(/* webpackChunkName: "add-blog-notification" */ '../views/notification/EditNotification.vue'),
  },
  {
    path: '/admin/notification/add-edm',
    name: 'AddEdmNotification',
    component: () => import(/* webpackChunkName: "add-edm-notification" */ '../views/notification/EditNotification.vue'),
  },
  {
    path: '/(admin/|sale/)?notification/:id(\\d+)',
    name: 'EditNotification',
    component: () => import(/* webpackChunkName: "edit-notification" */ '../views/notification/EditNotification.vue'),
  },
  {
    component: () => import(/* webpackChunkName: "community" */ '../views/advertisement/ListAdvertisement.vue'),
    path: '/(admin/|sale/)?community',
    name: 'Community',
  },
  {
    path: '/admin/company-intro-templates',
    name: 'ListCompanyIntroTemplate',
    component: () => import(/* webpackChunkName: "list-company-intro-template" */ '../views/company-intro-templates/List.vue'),
  },
  {
    path: '/admin/company-intro-templates/add',
    name: 'AddCompanyIntroTemplate',
    component: () => import(/* webpackChunkName: "add-company-intro-template" */ '../views/company-intro-templates/Edit.vue'),
  },
  {
    path: '/admin/company-intro-templates/:id(\\d+)',
    name: 'Edit',
    component: () => import(/* webpackChunkName: "edit-company-intro-template" */ '../views/company-intro-templates/Edit.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "help" */ '../views/static/FAQ.vue'),
  },
  {
    path: '/tnc',
    name: 'TNC',
    component: () => import(/* webpackChunkName: "tnc" */ '../views/static/TNC.vue'),
  },
  {
    path: '/setting',
    name: 'Setting',
    meta: { controller: 'setting' },
    component: () => import(/* webpackChunkName: "Setting" */ '../views/merchants/EditMerchant.vue'),
  },
  {
    path: '/sub-merchant',
    name: 'SubMerchant',
    component: () => import(/* webpackChunkName: "sub-merchant" */ '../views/merchants/ListSubMerchants.vue'),
  },
  {
    path: '/qr-scanner/scan',
    name: 'Scan',
    component: () => import(/* webpackChunkName: "Scan" */ '../views/qr-scanner/Scan.vue'),
  },
  {
    path: '/qr-scanner/coupon',
    name: 'ListQrCode',
    component: () => import(/* webpackChunkName: "qrcode-order" */ '../views/qr-scanner/ListCoupons.vue'),
  },
  {
    path: '/qr-scanner/coupon/:id(\\d+)',
    name: 'QrCodeOrderDetail',
    component: () => import(/* webpackChunkName: "qrcode-order-detail" */ '../views/qr-scanner/Detail.vue'),
  },
  {
    path: '/qr-scanner/scannedCoupons',
    name: 'ListScannedCoupons',
    component: () => import(/* webpackChunkName: "qr-scanner-list-scanned-coupons" */ '../views/qr-scanner/ListScannedCoupons.vue'),
  },
  {
    path: '/brandCreator',
    name: 'BrandCreator',
    component: () => import(/* webpackChunkName: "brand-Creator" */ '../views/static/BrandCreator.vue'),
  },
  {
    component: () => import(/* webpackChunkName: "list-creator-campaigns" */ '../views/creatorcampaign/ListCampaigns.vue'),
    path: '/(admin/|sale/)?creatorCampaigns',
    name: 'ListCreatorCampaigns',
  },
  {
    component: () => import(/* webpackChunkName: "creator-campaign-detail" */ '../views/creatorcampaign/CampaignDetail.vue'),
    path: '/(admin/|sale/)?creatorCampaigns/:id(\\d+)',
    name: 'CreatorCampaignDetail',
  },
  {
    path: '/(admin/|sale/)?creatorCampaigns/add',
    name: 'AddCreatorCampaign',
    component: () => import(/* webpackChunkName: "add-creator-campaign" */ '../views/creatorcampaign/EditCampaign.vue'),
  },
  {
    path: '/(admin/|sale/)?creatorCampaigns/:id(\\d+)/edit',
    name: 'EditCreatorCampaign',
    component: () => import(/* webpackChunkName: "edit-creator-campaign" */ '../views/creatorcampaign/EditCampaign.vue'),
  },
  {
    path: '/(admin/)?creatorCampaigns/searchCreator',
    name: 'SearchCreator',
    component: () => import(/* webpackChunkName: "search-creator" */ '../views/creatorcampaign/SearchCreator.vue'),
  },
  {
    path: '/rewardRedemption',
    name: 'RewardRedemption',
    component: () => import(/* webpackChunkName: "reward-redemption" */ '../views/rewardredemption/RewardRedemption.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    const toName = to.name;
    return new Promise((resolve) => {
      setTimeout(() => {
        if (!(toName === 'EditCoupon' || toName === 'EditPaymentCoupon' || toName === 'EditCheckinCoupon') && !to.hash) {
          resolve({ x: 0, y: 0 });
        }
      }, 500);
    });
  },
});

export default router;
